import { render } from "./CartTotals.vue?vue&type=template&id=373a3ee1"
import script from "./CartTotals.vue?vue&type=script&lang=js"
export * from "./CartTotals.vue?vue&type=script&lang=js"
script.render = render

export default script